module.exports = __webpack_public_path__ + "img/icon_cross-media.4d6dfd2c.png";